import { useTheme } from '@mui/material/styles';
import { HighlightOff } from '@mui/icons-material';

import DetailsList from '../../../../../../common/details-list';
import commonLocales from '../../../../../../../constants/locales';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationFailed } from './interfaces';

interface Props {
  operation: OperationFailed;
}

const FailureOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, amount, acquirerMsisdn, operator } = operation;

  const error =
    details.errorCode && details.errorMessage
      ? { errorCode: details.errorCode, errorMessage: details.errorMessage }
      : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            { label: commonLocales.operation.label.amount, value: formatToAmount(amount.value) },
            { label: commonLocales.operation.label.externalTransactionId, value: details.externalTransactionId },
            {
              label: commonLocales.operation.label.receiver,
              value: detailsValueFormatter(acquirerMsisdn)
            },
            { label: commonLocales.operation.label.referenceId, value: details.referenceId },
            { label: commonLocales.operation.label.operatorName, value: detailsValueFormatter(operator) }
          ]}
        />
      }
    />
  );
};

export default FailureOperation;
